module.exports = __webpack_public_path__ + "static/media/Unity_Technologies_logo.e5067f78.svg";